import { useState } from 'react';
import { Plus } from 'lucide-react';
import Table from '@/components/table/components/Table.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { expensesApiQueryKeys } from '@/features/dashboard/expenses/api/expensesApi.queryKeys.ts';
import expensesApi from '@/features/dashboard/expenses/api/expensesApi.ts';
import useExpenseRowActions from '@/features/dashboard/expenses/hooks/useExpenseRowActions.tsx';
import CreateExpenseModal from '@/features/dashboard/expenses/components/CreateExpenseModal.tsx';
import { ListSearch } from '@/components/table/routes/listSearchParams.ts';

interface TourExpensesTableProps {
  tourId: string;
  listSearch?: ListSearch;
}

const TourExpensesTable = ({ tourId, listSearch }: TourExpensesTableProps) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const { rowContextMenuItems, expenseRowModals } = useExpenseRowActions({
    tourIdOf: () => tourId,
  });

  return (
    <div>
      <Table
        listSearch={listSearch}
        queryKey={expensesApiQueryKeys.byTourId(tourId)}
        fetchData={expensesApi.getAll(tourId)}
        fetchTableDef={expensesApi.getTableDefinition(tourId)}
        rowContextMenuItems={rowContextMenuItems}
        title="Zaplanowane wydatki"
        primaryAction={
          <ActionButton
            tone="accent"
            size="xs"
            onClick={() => setIsCreateModalOpen(true)}
          >
            <Plus />
            Zaplanuj wydatek
          </ActionButton>
        }
      />

      {isCreateModalOpen && (
        <CreateExpenseModal
          tourId={tourId}
          onClose={() => setIsCreateModalOpen(false)}
        />
      )}

      {expenseRowModals}
    </div>
  );
};

export default TourExpensesTable;
